/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.mapDispatchToProps = exports.ConflictModal = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var PropertyHelper_1 = __importDefault(require("./helpers/PropertyHelper"));

var utils_1 = require("./utils");

var green_plus_png_1 = __importDefault(require("./assets/green-plus.png"));

var red_dash_png_1 = __importDefault(require("./assets/red-dash.png"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'ConflictModal';
exports.name = name;

var ConflictModal = function ConflictModal(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      Image = _ref.Image,
      Button = _ref.Button,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(_class, _react_1$default$Comp);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.proceed = _this.proceed.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "getThumbnailUrl",
      value: function getThumbnailUrl(s, env, model) {
        return PropertyHelper_1.default.getThumbnailUrl(env, model, s === null || s === void 0 ? void 0 : s.thumbnail);
      }
    }, {
      key: "proceed",
      value: function proceed(additions, subtractions) {
        var _this$props = this.props,
            closeModal = _this$props.closeModal,
            configuration = _this$props.configuration,
            setConfiguration = _this$props.setConfiguration;
        var newConfiguration = Object.assign({}, configuration);
        subtractions.forEach(function (s) {
          if (s.collection === 'attributes') {
            delete newConfiguration[s.id];
          } else {
            delete newConfiguration[s.attributeId];
          }
        });
        additions.forEach(function (a) {
          if (a.collection === 'attribute') {
            newConfiguration[a.id] = a.defaultPropertyId;
          } else {
            newConfiguration[a.attributeId] = a.id;
          }
        });
        setConfiguration(newConfiguration);
        closeModal();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            additions = _this$props2.additions,
            after = _this$props2.after,
            before = _this$props2.before,
            classes = _this$props2.classes,
            closeModal = _this$props2.closeModal,
            env = _this$props2.env,
            model = _this$props2.model,
            subtractions = _this$props2.subtractions;
        return react_1.default.createElement(Frame, {
          className: ['Modal__content', classes === null || classes === void 0 ? void 0 : classes.content],
          style: styles === null || styles === void 0 ? void 0 : styles.content
        }, before, react_1.default.createElement(Frame, {
          className: ['Modal__title-wrapper', classes === null || classes === void 0 ? void 0 : classes.titleWrapper],
          style: styles === null || styles === void 0 ? void 0 : styles.titleWrapper
        }, react_1.default.createElement(Text, {
          className: ['Modal__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, "Selection change required"), react_1.default.createElement(Text, {
          className: ['Modal__sub-title', classes === null || classes === void 0 ? void 0 : classes.subTitle],
          style: styles === null || styles === void 0 ? void 0 : styles.subTitle
        }, "The selection is not possible based upon previous selections.")), react_1.default.createElement(Frame, {
          className: ['Modal__subtractions', classes === null || classes === void 0 ? void 0 : classes.subtractions],
          style: styles === null || styles === void 0 ? void 0 : styles.subtractions
        }, subtractions.map(function (s) {
          return react_1.default.createElement(Frame, {
            className: ['Modal__row', classes === null || classes === void 0 ? void 0 : classes.row],
            style: styles === null || styles === void 0 ? void 0 : styles.row
          }, react_1.default.createElement(Frame, {
            className: ['Modal__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
            style: styles === null || styles === void 0 ? void 0 : styles.inner
          }, react_1.default.createElement(Image, {
            className: ['Modal__icon', classes === null || classes === void 0 ? void 0 : classes.icon],
            style: styles === null || styles === void 0 ? void 0 : styles.icon,
            src: red_dash_png_1.default
          }), react_1.default.createElement(Text, {
            className: ['Modal__action', classes === null || classes === void 0 ? void 0 : classes.action],
            style: styles === null || styles === void 0 ? void 0 : styles.action
          }, "Remove"), react_1.default.createElement(Frame, {
            className: ['Modal__thumbnailWrapper', classes === null || classes === void 0 ? void 0 : classes.thumbnailWrapper],
            style: styles === null || styles === void 0 ? void 0 : styles.thumbnailWrapper
          }, s.thumbnail && react_1.default.createElement(Image, {
            className: ['Modal__thumbnail', classes === null || classes === void 0 ? void 0 : classes.thumbnail],
            style: styles === null || styles === void 0 ? void 0 : styles.thumbnail,
            src: _this2.getThumbnailUrl(s, env, model)
          })), react_1.default.createElement(Frame, {
            className: ['Modal__option-wrapper', classes === null || classes === void 0 ? void 0 : classes.optionWrapper],
            style: styles === null || styles === void 0 ? void 0 : styles.optionWrapper
          }, react_1.default.createElement(Text, {
            className: ['Modal__option-title', classes === null || classes === void 0 ? void 0 : classes.optionTitle],
            style: styles === null || styles === void 0 ? void 0 : styles.optionTitle
          }, s.name), react_1.default.createElement(Text, {
            className: ['Modal__option-desc', classes === null || classes === void 0 ? void 0 : classes.optionDesc],
            style: styles === null || styles === void 0 ? void 0 : styles.optionDesc
          }, s.description)), react_1.default.createElement(Text, {
            className: ['Modal__optionPrice', classes === null || classes === void 0 ? void 0 : classes.optionPrice],
            style: styles === null || styles === void 0 ? void 0 : styles.optionPrice
          }, "-$", (s.price || 0).toLocaleString())), react_1.default.createElement(Frame, {
            className: ['Modal__mobile-desc', classes === null || classes === void 0 ? void 0 : classes.mobileDesc],
            style: styles === null || styles === void 0 ? void 0 : styles.mobilDesc
          }, react_1.default.createElement(Text, {
            className: ['Modal__option-desc', classes === null || classes === void 0 ? void 0 : classes.optionDesc],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.optionDesc), {
              display: 'flex'
            })
          }, s.description), react_1.default.createElement(Text, {
            className: ['Modal__optionPrice', classes === null || classes === void 0 ? void 0 : classes.optionPrice],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.optionPrice), {
              display: 'flex'
            })
          }, "-$", (s.price || 0).toLocaleString())));
        })), react_1.default.createElement(Frame, {
          className: ['Modal__additions', classes === null || classes === void 0 ? void 0 : classes.additions],
          style: styles === null || styles === void 0 ? void 0 : styles.additions
        }, additions.map(function (s) {
          return react_1.default.createElement(Frame, {
            className: ['Modal__row', classes === null || classes === void 0 ? void 0 : classes.row],
            style: styles === null || styles === void 0 ? void 0 : styles.row
          }, react_1.default.createElement(Frame, {
            className: ['Modal__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
            style: styles === null || styles === void 0 ? void 0 : styles.inner
          }, react_1.default.createElement(Image, {
            className: ['Modal__icon', classes === null || classes === void 0 ? void 0 : classes.icon],
            style: styles === null || styles === void 0 ? void 0 : styles.icon,
            src: green_plus_png_1.default
          }), react_1.default.createElement(Text, {
            className: ['Modal__action', classes === null || classes === void 0 ? void 0 : classes.action],
            style: styles === null || styles === void 0 ? void 0 : styles.action
          }, "Add"), react_1.default.createElement(Frame, {
            className: ['Modal__thumbnailWrapper', classes === null || classes === void 0 ? void 0 : classes.thumbnailWrapper],
            style: styles === null || styles === void 0 ? void 0 : styles.thumbnailWrapper
          }, s.thumbnail && react_1.default.createElement(Image, {
            className: ['Modal__thumbnail', classes === null || classes === void 0 ? void 0 : classes.thumbnail],
            style: styles === null || styles === void 0 ? void 0 : styles.thumbnail,
            src: _this2.getThumbnailUrl(s, env, model)
          })), react_1.default.createElement(Frame, {
            className: ['Modal__option-wrapper', classes === null || classes === void 0 ? void 0 : classes.optionWrapper],
            style: styles === null || styles === void 0 ? void 0 : styles.optionWrapper
          }, react_1.default.createElement(Text, {
            className: ['Modal__option-title', classes === null || classes === void 0 ? void 0 : classes.optionTitle],
            style: styles === null || styles === void 0 ? void 0 : styles.optionTitle
          }, s.name), react_1.default.createElement(Text, {
            className: ['Modal__option-desc', classes === null || classes === void 0 ? void 0 : classes.optionDesc],
            style: styles === null || styles === void 0 ? void 0 : styles.optionDesc
          }, s.description)), react_1.default.createElement(Text, {
            className: ['Modal__optionPrice', classes === null || classes === void 0 ? void 0 : classes.optionPrice],
            style: styles === null || styles === void 0 ? void 0 : styles.optionPrice
          }, "+$", (s.price || 0).toLocaleString())), react_1.default.createElement(Frame, {
            className: ['Modal__mobile-desc', classes === null || classes === void 0 ? void 0 : classes.mobileDesc],
            style: styles === null || styles === void 0 ? void 0 : styles.mobilDesc
          }, react_1.default.createElement(Text, {
            className: ['Modal__option-desc', classes === null || classes === void 0 ? void 0 : classes.optionDesc],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.optionDesc), {
              display: 'flex'
            })
          }, s.description), react_1.default.createElement(Text, {
            className: ['Modal__optionPrice', classes === null || classes === void 0 ? void 0 : classes.optionPrice],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.optionPrice), {
              display: 'flex'
            })
          }, "+$", (s.price || 0).toLocaleString())));
        })), react_1.default.createElement(Frame, {
          className: ['Modal__button-wrapper', classes === null || classes === void 0 ? void 0 : classes.buttonWrapper],
          style: styles === null || styles === void 0 ? void 0 : styles.buttonWrapper
        }, react_1.default.createElement(Button, {
          className: ['Modal__proceed', classes === null || classes === void 0 ? void 0 : classes.proceed],
          onClick: function onClick() {
            return _this2.proceed(additions, subtractions);
          }
        }, "Proceed"), react_1.default.createElement(Button, {
          className: ['Modal__cancel', classes === null || classes === void 0 ? void 0 : classes.cancel],
          onClick: function onClick() {
            return closeModal();
          }
        }, "Cancel")), after);
      }
    }]);

    return _class;
  }(react_1.default.Component);
};

exports.ConflictModal = ConflictModal;
var mapDispatchToProps = {
  closeModal: brightsmith_redux_1.Actions.Ui.closeModal,
  setConfiguration: brightsmith_redux_1.Actions.Configuration.set
};
exports.mapDispatchToProps = mapDispatchToProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      app = state.app;
  var configuration = api.configuration;
  var countryCode = app.countryCode,
      env = app.env;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var _ownProps$modalData = ownProps.modalData,
      modalData = _ownProps$modalData === void 0 ? {} : _ownProps$modalData;
  var _modalData$changes = modalData.changes,
      changes = _modalData$changes === void 0 ? [] : _modalData$changes,
      _modalData$selection = modalData.selection,
      selection = _modalData$selection === void 0 ? {} : _modalData$selection;
  var additions = [];
  var subtractions = [];
  changes.forEach(function (c) {
    var entry = c.collection === 'attributes' ? db.getAttribute(c.id) : db.getProperty(c.id, {
      countryCode: countryCode
    });

    if (c.action === 'remove') {
      subtractions.push(Object.assign(Object.assign({}, entry), c));
      return;
    }

    additions.push(Object.assign(Object.assign({}, entry), c));
  });
  var id = "".concat(Object.values(selection)[0]);
  additions.push(Object.assign({
    action: 'add',
    collection: 'properties',
    id: id
  }, db.getProperty(id, {
    countryCode: countryCode
  })));
  return {
    additions: additions,
    configuration: configuration,
    env: env,
    model: model,
    subtractions: subtractions
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;

  return {
    action: Object.assign({
      alignSelf: 'center',
      fontWeight: 'bold',
      marginLeft: 12,
      width: 70
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _a === void 0 ? void 0 : _a.action),
    buttonWrapper: Object.assign({
      marginTop: 30
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _b === void 0 ? void 0 : _b.buttonWrapper),
    cancel: Object.assign(_defineProperty({
      backgroundColor: '#A3A2A2',
      border: 0,
      boxSizing: 'border-box',
      color: '#000',
      cursor: 'pointer',
      fontSize: 25,
      fontWeight: 'bold',
      height: 60,
      textTransform: 'uppercase',
      width: 256
    }, "@media (max-width: ".concat((_c = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _c === void 0 ? void 0 : _c.mobile, "px)"), {
      width: '100%'
    }), (_d = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _d === void 0 ? void 0 : _d.cancel),
    icon: Object.assign(_defineProperty({
      alignSelf: 'center',
      display: 'flex',
      height: 36,
      width: 36
    }, "@media (max-width: ".concat((_e = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _e === void 0 ? void 0 : _e.mobile, "px)"), {
      height: 20,
      width: 20
    }), (_f = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _f === void 0 ? void 0 : _f.icon),
    inner: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flex: 1
    }, (_g = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _g === void 0 ? void 0 : _g.inner),
    mobileDesc: Object.assign(_defineProperty({
      display: 'none'
    }, "@media (max-width: ".concat((_h = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _h === void 0 ? void 0 : _h.mobile, "px)"), {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: 68,
      paddingTop: 8
    }), (_j = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _j === void 0 ? void 0 : _j.mobileDesc),
    optionDesc: Object.assign(_defineProperty({
      fontSize: 16
    }, "@media (max-width: ".concat((_k = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _k === void 0 ? void 0 : _k.mobile, "px)"), {
      display: 'none'
    }), (_l = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _l === void 0 ? void 0 : _l.optionDesc),
    optionPrice: Object.assign(_defineProperty({
      alignSelf: 'center',
      display: 'flex',
      fontSize: 20
    }, "@media (max-width: ".concat((_m = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _m === void 0 ? void 0 : _m.mobile, "px)"), {
      display: 'none'
    }), (_o = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _o === void 0 ? void 0 : _o.optionPrice),
    optionTitle: Object.assign({
      fontSize: 20
    }, (_p = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _p === void 0 ? void 0 : _p.optionTitle),
    optionWrapper: Object.assign({
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center'
    }, (_q = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _q === void 0 ? void 0 : _q.optionWrapper),
    proceed: Object.assign(_defineProperty({
      backgroundColor: '#000000',
      border: 0,
      boxSizing: 'border-box',
      color: '#FFF',
      cursor: 'pointer',
      fontSize: 25,
      fontWeight: 'bold',
      marginRight: 20,
      height: 60,
      textTransform: 'uppercase',
      width: 256
    }, "@media (max-width: ".concat((_r = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _r === void 0 ? void 0 : _r.mobile, "px)"), {
      marginBottom: 10,
      marginRight: 0,
      width: '100%'
    }), (_s = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _s === void 0 ? void 0 : _s.proceed),
    row: Object.assign(_defineProperty({
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 10,
      paddingTop: 10,
      width: '100%'
    }, "@media (max-width: ".concat((_t = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _t === void 0 ? void 0 : _t.mobile, "px)"), {
      flexDirection: 'column'
    }), (_u = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _u === void 0 ? void 0 : _u.row),
    subtitle: Object.assign({
      fontSize: 28,
      marginBottom: 20
    }, (_v = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _v === void 0 ? void 0 : _v.subTitle),
    subtractions: Object.assign({}, utils_1.StyleUtils.borderBottom('1px solid #707070')),
    title: Object.assign(_defineProperty({
      fontSize: 48,
      fontWeight: 'bold'
    }, "@media (max-width: ".concat((_w = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _w === void 0 ? void 0 : _w.mobile, "px)"), {
      fontSize: 24
    }), (_x = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _x === void 0 ? void 0 : _x.title),
    thumbnail: Object.assign({
      height: '100%',
      width: 'auto'
    }, (_y = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _y === void 0 ? void 0 : _y.thumbnail),
    thumbnailWrapper: Object.assign(Object.assign(Object.assign({
      alignSelf: 'center'
    }, utils_1.StyleUtils.border('1px solid #E3E3E3')), _defineProperty({
      display: 'flex',
      height: 90,
      justifyContent: 'center',
      marginLeft: 30,
      marginRight: 15,
      overflow: 'hidden',
      width: 90
    }, "@media (max-width: ".concat((_z = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _z === void 0 ? void 0 : _z.mobile, "px)"), {
      height: 48,
      width: 48
    })), (_0 = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _0 === void 0 ? void 0 : _0.thumbnailWrapper),
    titleWrapper: Object.assign({}, (_1 = theme === null || theme === void 0 ? void 0 : theme.ConflictModal) === null || _1 === void 0 ? void 0 : _1.titleWrapper)
  };
};

exports.style = style;